module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-product-skin.313e424a.png";